import type { ControllingOwner } from '../types/formK.types';

/**
 * Returns default values for a new controlling owner entry
 * Used when adding new controlling owner to the form
 */
export const getDefaultControllingOwnerValues = (): ControllingOwner => ({
  lastName: '',
  firstName: '',
  address: '',
  postalCode: '',
  city: '',
  country: '',
  companyName: '',
  nationality: '',
});

/**
 * Handles checkbox change for multi-select fields
 * Adds or removes value from the current selection array
 */
export const handleCheckboxChange = (
  checked: boolean,
  value: string,
  currentValue: string[] | undefined
): string[] => {
  const current = currentValue || [];

  if (checked) {
    // Add to selection
    return [...current, value];
  } else {
    // Remove from selection
    return current.filter(v => v !== value);
  }
};

/**
 * Checks if "other" is selected in origin of assets
 * Used to conditionally show the "other" text input field
 */
export const shouldShowOriginOfAssetsOther = (
  originOfAssets?: string[]
): boolean => {
  return originOfAssets?.includes('other') ?? false;
};
